import { Routes } from '@angular/router';
import { AuthCallbackComponent } from 'auth-callback-lib';
import { BullhornLoginAssistantComponent } from './bullhorn-login-assistant/bullhorn-login-assistant.component';
import { BullhornSessionIdentityComponent } from './bullhorn-session-identity/bullhorn-session-identity.component';
import { BwMcpChatComponent } from './bw-mcp-chat/bw-mcp-chat.component';
import { CandidateRatingAgentComponent } from './candidate-rating-agent/candidate-rating-agent.component';
import { ChatComponent } from './chat/chat.component';
import { ClientReengagementComponent } from './client-reengagement/client-reengagement.component';
import { ConnectionsComponent } from './connections/connections.component';
import { CvFormatterComponent } from './cv-formatter/cv-formatter.component';
import { HomeComponent } from './home/home.component';
import { InterviewPrepBriefComponent } from './interview-prep-brief/interview-prep-brief.component';
import { SettingsComponent } from './settings/settings.component';
import { UsageLimitsComponent } from './usage-limits/usage-limits.component';
import { authGuard } from './auth.guard';

export const appRoutes: Routes = [
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'chat', component: ChatComponent, canActivate: [authGuard] },
  { path: 'bw-mcp-chat', component: BwMcpChatComponent, canActivate: [authGuard] },
  { path: 'bullhorn-login-assistant', component: BullhornLoginAssistantComponent, canActivate: [authGuard] },
  { path: 'bullhorn-session-identity', component: BullhornSessionIdentityComponent, canActivate: [authGuard] },
  { path: 'candidate-rating-agent', component: CandidateRatingAgentComponent, canActivate: [authGuard] },
  { path: 'interview-prep-brief', component: InterviewPrepBriefComponent, canActivate: [authGuard] },
  { path: 'cv-formatter', component: CvFormatterComponent, canActivate: [authGuard] },
  { path: 'client-reengagement', component: ClientReengagementComponent, canActivate: [authGuard] },
  { path: 'connections', component: ConnectionsComponent, canActivate: [authGuard] },
  { path: 'usage-limits', component: UsageLimitsComponent, canActivate: [authGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
  { path: 'callback', component: AuthCallbackComponent },
  { path: '**', redirectTo: '' },
];
